import React, { Component } from "react";
import PropTypes from "prop-types";
import PasswordValidationSettings from "../../../entities/PasswordValidationSettings";
import PasswordForm from "./PasswordForm";
import PasswordValidationUserData from "../../../entities/PasswordValidationUserData";

const ResetPassword = (props) => {
    return (
        <div id="resetPassword" className="account-popup">
            <div className="signIn-form-title">Reset Password</div>
            <div className="email">
                <b>{props.email}</b>
            </div>
            <PasswordForm
                buttonText={"Reset Password"}
                onComplete={props.onComplete}
                passwordRequirements={props.passwordRequirements}
                passwordValidationUserData={props.passwordValidationUserData}
                serverError={props.serverError}
                errorSummary={"Reset Password Failed"}
                isPasswordSetting={props.isPasswordSetting}
            />
        </div>);
};

ResetPassword.propTypes = {
    email: PropTypes.string,
    serverError: PropTypes.string,
    onComplete: PropTypes.func,
    passwordRequirements: PropTypes.instanceOf(PasswordValidationSettings),
    passwordValidationUserData: PropTypes.instanceOf(PasswordValidationUserData),
    isPasswordSetting: PropTypes.bool
};

export default ResetPassword;
